import React from 'react';
import { Provider } from 'react-redux';
import { store } from '../store'; // Adjust the path as necessary
import RouterComponent from '../Router/Router';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <RouterComponent />
    </Provider>
  );
};

export default App;
